import packageConfig from '../../../package.json'

const baseUrl = `${process.env.VUE_APP_RESOURCE_URL}`;
const imgUrl = `${baseUrl}/ct_hisSystem/images`;
const imgArr = {
    error404: `${imgUrl}/404.jpg?v=${packageConfig.version}`,
    account: `${imgUrl}/account.jpg?v=${packageConfig.version}`,
    alipay: `${imgUrl}/alipay.png?v=${packageConfig.version}`,
    bookIcon: `${imgUrl}/book-icon.png?v=${packageConfig.version}`,
    callNum: `${imgUrl}/callNum.png?v=${packageConfig.version}`,
    cash: `${imgUrl}/cash.png?v=${packageConfig.version}`,
    codeScan: `${imgUrl}/codeScan.jpg?v=${packageConfig.version}`,
    comboIcon: `${imgUrl}/combo-icon.png?v=${packageConfig.version}`,
    crad: `${imgUrl}/crad.png?v=${packageConfig.version}`,
    dangan: `${imgUrl}/dangan.png?v=${packageConfig.version}`,
    dataBoard: `${imgUrl}/dataBoard.png?v=${packageConfig.version}`,
    dataBoardNew: `${imgUrl}/dataBoardNew.png?v=${packageConfig.version}`,
    delIcon: `${imgUrl}/del-icon.png?v=${packageConfig.version}`,
    deleteIcon: `${imgUrl}/delete-icon.png?v=${packageConfig.version}`,
    doctor: `${imgUrl}/doctor.jpg?v=${packageConfig.version}`,
    dragIcon: `${imgUrl}/drag-icon.jpg?v=${packageConfig.version}`,
    drugIcon: `${imgUrl}/drugIcon.png?v=${packageConfig.version}`,
    explainIcon: `${imgUrl}/explain-icon.png?v=${packageConfig.version}`,
    file: `${imgUrl}/file.png?v=${packageConfig.version}`,
    girlIcon: `${imgUrl}/girl-icon.png?v=${packageConfig.version}`,
    haomuch: `${imgUrl}/haomuch.png?v=${packageConfig.version}`,
    howmuch: `${imgUrl}/howmuch.png?v=${packageConfig.version}`,
    kong: `${imgUrl}/kong.png?v=${packageConfig.version}`,
    login_bg: `${imgUrl}/login_bg.jpg?v=${packageConfig.version}`,
    logo: `${imgUrl}/logo.png?v=${packageConfig.version}`,
    logo1: `${imgUrl}/logo1.png?v=${packageConfig.version}`,
    manIcon: `${imgUrl}/man-icon.png?v=${packageConfig.version}`,
    note: `${imgUrl}/note.png?v=${packageConfig.version}`,
    phyIcon: `${imgUrl}/phyIcon.png?v=${packageConfig.version}`,
    plus: `${imgUrl}/plus.png?v=${packageConfig.version}`,
    pring: `${imgUrl}/pring.png?v=${packageConfig.version}`,
    printIcon: `${imgUrl}/print-icon.png?v=${packageConfig.version}`,
    refund: `${imgUrl}/refund.png?v=${packageConfig.version}`,
    scan: `${imgUrl}/scan.png?v=${packageConfig.version}`,
    shortcutKey: `${imgUrl}/shortcutKey.png?v=${packageConfig.version}`,
    Slice: `${imgUrl}/Slice.png?v=${packageConfig.version}`,
    static: `${imgUrl}/static.png?v=${packageConfig.version}`,
    statusBg1: `${imgUrl}/statusBg1.png?v=${packageConfig.version}`,
    statusBg2: `${imgUrl}/statusBg2.png?v=${packageConfig.version}`,
    statusBg3: `${imgUrl}/statusBg3.png?v=${packageConfig.version}`,
    statusBg4: `${imgUrl}/statusBg4.png?v=${packageConfig.version}`,
    voice_l: `${imgUrl}/voice-l.png?v=${packageConfig.version}`,
    voice_play_l: `${imgUrl}/voice-play-l.gif?v=${packageConfig.version}`,
    voice_play_r: `${imgUrl}/voice-play-r.gif?v=${packageConfig.version}`,
    voice_r: `${imgUrl}/voice-r.png?v=${packageConfig.version}`,
    wechat: `${imgUrl}/wechat.png?v=${packageConfig.version}`,
    weixin: `${imgUrl}/weixin.jpg?v=${packageConfig.version}`,
    changeType: `${imgUrl}/changeType.png?v=${packageConfig.version}`,
    chineseMedicineIcon: `${imgUrl}/chineseMedicine-icon.jpg?v=${packageConfig.version}`,
    formulaIcon: `${imgUrl}/formula-icon.png?v=${packageConfig.version}`,
    star: `${imgUrl}/star.png?v=${packageConfig.version}`,
    uploadImg: `${imgUrl}/upload-img.png?v=${packageConfig.version}`,
    kaiPiaoZhong: `${imgUrl}/kaiPiaoZhong.png?v=${packageConfig.version}`,
    yiZuoFei: `${imgUrl}/yiZuoFei.png?v=${packageConfig.version}`,
    yiHongChong: `${imgUrl}/yiHongChong.png?v=${packageConfig.version}`,
    yiKaiPiao: `${imgUrl}/yiKaiPiao.png?v=${packageConfig.version}`,
    greenMark: `${imgUrl}/greenMark.png?v=${packageConfig.version}`,
    grayMark: `${imgUrl}/grayMark.png?v=${packageConfig.version}`,
    acupointIcon: `${imgUrl}/acupoint-icon.png?v=${packageConfig.version}`,
    executeIcon: `${imgUrl}/executeIcon.png?v=${packageConfig.version}`,
    formulaNoData: `${imgUrl}/formula-no-data.png?v=${packageConfig.version}`,
    pickIcon: `${imgUrl}/pickIcon.png?v=${packageConfig.version}`,
    companyIcon1: `${imgUrl}/companyIcon1.png?v=${packageConfig.version}`,
    companyIcon2: `${imgUrl}/companyIcon2.png?v=${packageConfig.version}`,
    companyIcon3: `${imgUrl}/companyIcon3.png?v=${packageConfig.version}`,
    couponScan: `${imgUrl}/couponScan.png?v=${packageConfig.version}`,
    couponPhone: `${imgUrl}/couponPhone.png?v=${packageConfig.version}`,
    noCoupon: `${imgUrl}/noCoupon.png?v=${packageConfig.version}`,
    traceCodesError: `${imgUrl}/traceCodes-error.png?v=${packageConfig.version}`,
    traceCodesSuccess: `${imgUrl}/traceCodes-Success.png?v=${packageConfig.version}`,
    a1: `${imgUrl}/a1.png?v=${packageConfig.version}`,
    a2: `${imgUrl}/a2.json?v=${packageConfig.version}`,
    a3: `${imgUrl}/a3.png?v=${packageConfig.version}`,
    a4: `${imgUrl}/a4.png?v=${packageConfig.version}`,
    a5: `${imgUrl}/a5.png?v=${packageConfig.version}`,
    a6: `${imgUrl}/a6.png?v=${packageConfig.version}`,
    a7: `${imgUrl}/a7.png?v=${packageConfig.version}`,
    chat_user: `${imgUrl}/chat_user.png?v=${packageConfig.version}`,
    inquiry: `${imgUrl}/inquiry.png?v=${packageConfig.version}`,
    sendImage: `${imgUrl}/sendImage.png?v=${packageConfig.version}`,
    giveTime: `${imgUrl}/giveTime.png?v=${packageConfig.version}`,
    chatHistory: `${imgUrl}/chatHistory.png?v=${packageConfig.version}`,
    refundNumber: `${imgUrl}/refundNumber.png?v=${packageConfig.version}`,
    overConsultation: `${imgUrl}/overConsultation.png?v=${packageConfig.version}`,
    vipCard: `${imgUrl}/vipCard.png?v=${packageConfig.version}`,
    doctorData_ranking: `${imgUrl}/doctorData_ranking.png?v=${packageConfig.version}`,
    doctorData_people: `${imgUrl}/doctorData_people.png?v=${packageConfig.version}`,
    doctorData_followUpVisit: `${imgUrl}/doctorData_followUpVisit.png?v=${packageConfig.version}`,
    doctorData_money: `${imgUrl}/doctorData_money.png?v=${packageConfig.version}`,
    a8: `${imgUrl}/a8.png?v=${packageConfig.version}`,
    present: `${imgUrl}/present.png?v=${packageConfig.version}`,
    meituan_ticket: `${imgUrl}/meituan_ticket.png?v=${packageConfig.version}`,
    a8: `${imgUrl}/a8.png?v=${packageConfig.version}`,
    a9: `${imgUrl}/a9.png?v=${packageConfig.version}`,
    a10: `${imgUrl}/a10.png?v=${packageConfig.version}`,
    a11: `${imgUrl}/a11.png?v=${packageConfig.version}`,
    a12: `${imgUrl}/a12.png?v=${packageConfig.version}`,
    a13: `${imgUrl}/a13.png?v=${packageConfig.version}`,
    a14: `${imgUrl}/a14.png?v=${packageConfig.version}`,
    a15: `${imgUrl}/a15.png?v=${packageConfig.version}`,
    a16: `${imgUrl}/a16.png?v=${packageConfig.version}`,
    a17: `${imgUrl}/a17.png?v=${packageConfig.version}`,
    a18: `${imgUrl}/a18.png?v=${packageConfig.version}`,
}
export {
    imgArr
}